/**
 * OBGH Anti-Tampering Protection
 * Detects DevTools, prevents source copying, and protects proprietary code
 */

const DEVTOOLS_WARNING = 'OBGH TERRITOIRE PRO - ACCES NON AUTORISE DETECTE. Toute tentative de copier, extraire ou analyser le code source est strictement interdite et passible de poursuites. Voir Section 3 des conditions d\'utilisation.';

let devtoolsOpen = false;

// Detect DevTools via window size difference
function checkDevTools() {
  const widthDiff = window.outerWidth - window.innerWidth > 160;
  const heightDiff = window.outerHeight - window.innerHeight > 160;
  if (widthDiff || heightDiff) {
    if (!devtoolsOpen) {
      devtoolsOpen = true;
      console.clear();
      console.log('%c ARRET!', 'color: red; font-size: 60px; font-weight: bold; text-shadow: 2px 2px black;');
      console.log('%c ' + DEVTOOLS_WARNING, 'color: #f97316; font-size: 14px; font-weight: bold;');
    }
  } else {
    devtoolsOpen = false;
  }
}

// Disable right-click context menu
function blockContextMenu(e) {
  e.preventDefault();
}

// Disable keyboard shortcuts for DevTools / View Source
function blockDevToolsKeys(e) {
  // F12
  if (e.key === 'F12') { e.preventDefault(); return; }
  // Ctrl+Shift+I (DevTools)
  if (e.ctrlKey && e.shiftKey && e.key === 'I') { e.preventDefault(); return; }
  // Ctrl+Shift+J (Console)
  if (e.ctrlKey && e.shiftKey && e.key === 'J') { e.preventDefault(); return; }
  // Ctrl+U (View Source)
  if (e.ctrlKey && e.key === 'u') { e.preventDefault(); return; }
  // Ctrl+S (Save page)
  if (e.ctrlKey && e.key === 's') { e.preventDefault(); return; }
  // Ctrl+Shift+C (Inspect element)
  if (e.ctrlKey && e.shiftKey && e.key === 'C') { e.preventDefault(); return; }
}

// Disable text selection on sensitive elements
function disableSelection() {
  const style = document.createElement('style');
  style.textContent = `
    [data-protected], .obgh-protected {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }
  `;
  document.head.appendChild(style);
}

export function initProtection() {
  if (process.env.NODE_ENV === 'development') return; // Skip in dev

  // Check DevTools periodically
  setInterval(checkDevTools, 2000);

  // Block context menu
  document.addEventListener('contextmenu', blockContextMenu);

  // Block DevTools shortcuts
  document.addEventListener('keydown', blockDevToolsKeys);

  // Disable selection on protected elements
  disableSelection();
}

export function cleanupProtection() {
  document.removeEventListener('contextmenu', blockContextMenu);
  document.removeEventListener('keydown', blockDevToolsKeys);
}
